var path = '/templates/projects.settings/index.html';
var html = "<div id=installation><div class=container><div class=config-wrapper><div class=config-menu><div ui-view=menu></div></div><div class=config-submenu><div ui-view=submenu></div></div><div class=config-content><div class=config-content-wrapper><div ui-view=content></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.settings/index.html
// module id = 1528
// module chunks = 0